<div class="" (window:resize)="isMobile($event)">
  <app-sidebar
    [ngClass]="{ 'sidenav fixed-left': isMobileResolution === false }"
  ></app-sidebar>
  <div class="main-content">
    <app-navbar
        [bgColor]="isGrayNavbar ? '#7F7F7F' : '#888'"
    >
    </app-navbar>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</div>